/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetDerivedModel
 */
export interface PetDerivedModel {
    /**
     * System assigned. populated based on the pet type, gender, and sterilization database values
     * @type {string}
     * @memberof PetDerivedModel
     */
    genderAndSterilization?: string;
}

/**
 * Check if a given object implements the PetDerivedModel interface.
 */
export function instanceOfPetDerivedModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetDerivedModelFromJSON(json: any): PetDerivedModel {
    return PetDerivedModelFromJSONTyped(json, false);
}

export function PetDerivedModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetDerivedModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'genderAndSterilization': !exists(json, 'genderAndSterilization') ? undefined : json['genderAndSterilization'],
    };
}

export function PetDerivedModelToJSON(value?: PetDerivedModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'genderAndSterilization': value.genderAndSterilization,
    };
}

